import { css, slotted } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { display } from '../../foundation/display';

export const formFieldStyles = css`
    ${display('block')} :host {
        width: 100%;
        text-align: center;
    }

    :host([orientation="left"]) {
        text-align: left;
    }

    :host([orientation="right"]) {
        text-align: right;
    }

    .control {
        margin-top: calc(${getToken('space-design-unit')} * ${getToken('space-form-label-gap-units')} * 1px);
    }

    ::slotted([slot="validation"]) {
        color: ${getToken('color-error')};
    }
`;
